//Constants defining payment mode.
export const TRANSFERMATE_PAYMENT_MODE = {
  CARD: 'card',
  BANK_TRANSFER: 'bank_transfer',
  BACS: 'bacs',
}

export const STRIPE_PAYMENT_MODE = [
  TRANSFERMATE_PAYMENT_MODE.CARD,
  TRANSFERMATE_PAYMENT_MODE.BACS,
]

export const TRANSFERMATE_BANK_TRANSFER_ID = 0;
export const TRANSFERMATE_BANK_TRANSFER_ID_PSE = 19;
export const TRANSFERMATE_CREDIT_DEBIT_CARD = 18;

export const CHINA_COUNTRY_CODE = 'CN';
export const INDIA_COUNTRY_CODE = 'IN';

export const tranfermatePayerCountryRegex = {
  AR: { label: "DNI or CUIT", regex: /^(?=[0-9]*$)(?:.{7,9}|.{11})$/, helper_text: "This should be 7, 9 or 11 digits" },
  BO: { label: "CI", regex: /^(?=[0-9]*$)(?:.{5,20})$/ , helper_text: "This should be 5 to 20 digits"},
  BR: { label: "CPF", regex: /^(\d{3}\.\d{3}\.\d{3}-\d{2})$/, helper_text: "This should be 11 digit number. Ex:123.456.789-10" },
  CL: { label: "CI/RUT", regex: /^(?:.{8,9})$/ , helper_text: "This should be 8 or 9 digits"},
  CN: { label: "Citizen ID Number", regex: /^([1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])$/ , helper_text: "This should be 18 digits"},
  CO: { label: "CC", regex: /^(?=[0-9]*$)(?:.{6,10})$/ , helper_text: "This should be 6 to 10 digits"},
  EC: { label: "CI", regex: /^(?=[0-9]*$)(?:.{5,20})$/ , helper_text: "This should be 5 to 20 digits"},
  EG: { label: "ID", regex: /^(?=[0-9]*$)(?:.{14})$/ , helper_text: "This should be 14 digits"},
  IN: { label: "Payer PAN", regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, helper_text: "This should be 10 digits. Ex:AAAAA1234A" },
  ID: { label: "NIK", regex: /^(?=[0-9]*$)(?:.{16})$/ , helper_text: "This should be 16 digits"},
  MX: { label: "CURP", regex: /^(?:.{10,18})$/ , helper_text: "This should be 10 to 18 digits"},
  MA: { label: "CNIE", regex: /^(?:.{5,20})$/ , helper_text: "This should be 5 to 20 digits"},
  NG: { label: "NIN", regex: /^(?=[0-9]*$)(?:.{11})$/ , helper_text: "This should be 11 digits"},
  PY: { label: "CI", regex: /^(?=[0-9]*$)(?:.{5,20})$/ , helper_text: "This should be 5 to 20 digits"},
  PE: { label: "DNI", regex: /^(?=[0-9]*$)(?:.{8,9})$/ , helper_text: "This should be 8 or 9 digits"},
  ZA: { label: "ID", regex: /^(?=[0-9]*$)(?:.{5,20})$/ , helper_text: "This should be 5 to 20 digits"},
  TR: { label: "T.C. Kimlik No.", regex: /^(?=[0-9]*$)(?:.{5,20})$/ , helper_text: "This should be 5 to 20 digits"},
  US: { label: "SSN", regex: /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/, helper_text: "This should be 9 digits. Ex:123-45-6789"},
  UY: { label: "CI", regex: /^(?=[0-9]*$)(?:.{6,8})$/ , helper_text: "This should be 6 to 8 digits"},
};

export const tranfermateStudentCountryRegex = {
  BR: { label: "CPF", regex: /^(\d{3}\.\d{3}\.\d{3}-\d{2})$/, helper_text: "This should be 11 digit number. Ex:123.456.789-10" },
  CN: { label: "Citizen ID Number", regex: /^([1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])$/ , helper_text: "This should be 18 digits"},
};

export const TRANSFERMATE_COUNTRY_CODE = [
  {
    name: 'Afghanistan',
    value: 'AF'
  },
  {
    name: 'Aland Islands', 
    value: 'AX'
  },
  {
    name: 'Albania',
    value: 'AL'
  },
  {
    name: 'Algeria',
    value: 'DZ'
  },
  {
    name: 'American Samoa',
    value: 'AS'
  },
  {
    name: 'Andorra',
    value: 'AD'
  },
  {
    name: 'Angola',
    value: 'AO'
  },
  {
    name: 'Anguilla',
    value: 'AI'
  },
  {
    name: 'Antigua and Barbuda',
    value: 'AG'
  },
  {
    name: 'Argentina',
    value: 'AR'
  },
  {
    name: 'Armenia',
    value: 'AM'
  },
  {
    name: 'Aruba',
    value: 'AW'
  },
  {
    name: 'Australia',
    value: 'AU'
  },
  {
    name: 'Austria',
    value: 'AT'
  },
  {
    name: 'Azerbaijan',
    value: 'AZ'
  },
  {
    name: 'Bahamas',
    value: 'BS'
  },
  {
    name: 'Bahrain',
    value: 'BH'
  },
  {
    name: 'Bangladesh',
    value: 'BD'
  },
  {
    name: 'Barbados',
    value: 'BB'
  },
  {
    name: 'Belarus',
    value: 'BY'
  },
  {
    name: 'Belgium',
    value: 'BE'
  },
  {
    name: 'Belize',
    value: 'BZ'
  },
  {
    name: 'Benin',
    value: 'BJ'
  },
  {
    name: 'Bermuda',
    value: 'BM'
  },
  {
    name: 'Bhutan',
    value: 'BT'
  },
  {
    name: 'Bolivia',
    value: 'BO'
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    value: 'BQ'
  },
  {
    name: 'Bosnia and Herzegovina',
    value: 'BA'
  },
  {
    name: 'Botswana',
    value: 'BW'
  },
  {
    name: 'Bouvet Island',
    value: 'BV'
  },
  {
    name: 'Brazil',
    value: 'BR'
  },
  {
    name: 'Brunei',
    value: 'BN'
  },
  {
    name: 'Bulgaria',
    value: 'BG'
  },
  {
    name: 'Burkina Faso',
    value: 'BF'
  },
  {
    name: 'Burundi',
    value: 'BI'
  },
  {
    name: 'Cape Verde',
    value: 'CV'
  },
  {
    name: 'Cambodia',
    value: 'KH'
  },
  {
    name: 'Cameroon',
    value: 'CM'
  },
  {
    name: 'Canada',
    value: 'CA'
  },
  {
    name: 'Cayman Islands',
    value: 'KY'
  },
  {
    name: 'Central African Republic',
    value: 'CF'
  },
  {
    name: 'Chad',
    value: 'TD'
  },
  {
    name: 'Chile',
    value: 'CL'
  },
  {
    name: 'China',
    value: 'CN'
  },
  {
    name: 'Christmas Island',
    value: 'CX'
  },
  {
    name: 'Cocos (Keeling) Islands',
    value: 'CC'
  },
  {
    name: 'Colombia',
    value: 'CO'
  },
  {
    name: 'Comoros',
    value: 'KM'
  },
  {
    name: 'Congo (Republic of the Congo)',
    value: 'CG'
  },
  {
    name: 'Congo',
    value: 'CD'
  },
  {
    name: 'Cook Islands',
    value: 'CK'
  },
  {
    name: 'Costa Rica',
    value: 'CR'
  },
  {
    name: "Côte d'Ivoire",
    value: 'CI'
  },
  {
    name: 'Croatia',
    value: 'HR'
  },
  {
    name: 'Cuba',
    value: 'CU'
  },
  {
    name: 'Curaçao',
    value: 'CW'
  },
  {
    name: 'Cyprus',
    value: 'CY'
  },
  {
    name: 'Czech Republic',
    value: 'CZ'
  },
  {
    name: 'Denmark',
    value: 'DK'
  },
  {
    name: 'Djibouti',
    value: 'DJ'
  },
  {
    name: 'Dominica',
    value: 'DM'
  },
  {
    name: 'Dominican Republic',
    value: 'DO'
  },
  {
    name: 'Ecuador',
    value: 'EC'
  },
  {
    name: 'Egypt',
    value: 'EG'
  },
  {
    name: 'El Salvador',
    value: 'SV'
  },
  {
    name: 'Equatorial Guinea',
    value: 'GQ'
  },
  {
    name: 'Eritrea',
    value: 'ER'
  },
  {
    name: 'Estonia',
    value: 'EE'
  },
  {
    name: 'Eswatini',
    value: 'SZ'
  },
  {
    name: 'Ethiopia',
    value: 'ET'
  },
  {
    name: 'Falkland Islands (Malvinas)',
    value: 'FK'
  },
  {
    name: 'Faroe Islands',
    value: 'FO'
  },
  {
    name: 'Fiji Islands',
    value: 'FJ'
  },
  {
    name: 'Finland',
    value: 'FI'
  },
  {
    name: 'France',
    value: 'FR'
  },
  {
    name: 'French Guiana',
    value: 'GF'
  },
  {
    name: 'French Polynesia',
    value: 'PF'
  },
  {
    name: 'French Southern Territories',
    value: 'TF'
  },
  {
    name: 'Gabon',
    value: 'GA'
  },
  {
    name: 'Gambia',
    value: 'GM'
  },
  {
    name: 'Georgia',
    value: 'GE'
  },
  {
    name: 'Germany',
    value: 'DE'
  },
  {
    name: 'Ghana',
    value: 'GH'
  },
  {
    name: 'Gibraltar',
    value: 'GI'
  },
  {
    name: 'Greece',
    value: 'GR'
  },
  {
    name: 'Greenland',
    value: 'GL'
  },
  {
    name: 'Grenada',
    value: 'GD'
  },
  {
    name: 'Guadeloupe',
    value: 'GP'
  },
  {
    name: 'Guam',
    value: 'GU'
  },
  {
    name: 'Guatemala',
    value: 'GT'
  },
  {
    name: 'Guernsey',
    value: 'GG'
  },
  {
    name: 'Guinea',
    value: 'GN'
  },
  {
    name: 'Guinea-Bissau',
    value: 'GW'
  },
  {
    name: 'Guyana',
    value: 'GY'
  },
  {
    name: 'Haiti',
    value: 'HT'
  },
  {
    name: 'Honduras',
    value: 'HN'
  },
  {
    name: 'Hong Kong S.A.R',
    value: 'HK'
  },
  {
    name: 'Hungary',
    value: 'HU'
  },
  {
    name: 'Iceland',
    value: 'IS'
  },
  {
    name: 'India',
    value: 'IN'
  },
  {
    name: 'Indonesia',
    value: 'ID'
  },
  {
    name: 'Iran',
    value: 'IR'
  },
  {
    name: 'Iraq',
    value: 'IQ'
  },
  {
    name: 'Ireland',
    value: 'IE'
  },
  {
    name: 'Isle of Man',
    value: 'IM'
  },
  {
    name: 'Israel',
    value: 'IL'
  },
  {
    name: 'Italy',
    value: 'IT'
  },
  {
    name: 'Jamaica',
    value: 'JM'
  },
  {
    name: 'Japan',
    value: 'JP'
  },
  {
    name: 'Jersey',
    value: 'JE'
  },
  {
    name: 'Jordan',
    value: 'JO'
  },
  {
    name: 'Kazakhstan',
    value: 'KZ'
  },
  {
    name: 'Kenya',
    value: 'KE'
  },
  {
    name: 'Kiribati',
    value: 'KI'
  },
  {
    name: 'Kuwait',
    value: 'KW'
  },
  {
    name: 'Kyrgyzstan',
    value: 'KG'
  },
  {
    name: 'Laos',
    value: 'LA'
  },
  {
    name: 'Latvia',
    value: 'LV'
  },
  {
    name: 'Lebanon',
    value: 'LB'
  },
  {
    name: 'Lesotho',
    value: 'LS'
  },
  {
    name: 'Liberia',
    value: 'LR'
  },
  {
    name: 'Libya',
    value: 'LY'
  },
  {
    name: 'Liechtenstein',
    value: 'LI'
  },
  {
    name: 'Lithuania',
    value: 'LT'
  },
  {
    name: 'Luxembourg',
    value: 'LU'
  },
  {
    name: 'Macau S.A.R',
    value: 'MO'
  },
  {
    name: 'Madagascar',
    value: 'MG'
  },
  {
    name: 'Malawi',
    value: 'MW'
  },
  {
    name: 'Malaysia',
    value: 'MY'
  },
  {
    name: 'Maldives',
    value: 'MV'
  },
  {
    name: 'Mali',
    value: 'ML'
  },
  {
    name: 'Malta',
    value: 'MT'
  },
  {
    name: 'Marshall Islands',
    value: 'MH'
  },
  {
    name: 'Martinique',
    value: 'MQ'
  },
  {
    name: 'Mauritania',
    value: 'MR'
  },
  {
    name: 'Mauritius',
    value: 'MU'
  },
  {
    name: 'Mayotte',
    value: 'YT'
  },
  {
    name: 'Mexico',
    value: 'MX'
  },
  {
    name: 'Micronesia',
    value: 'FM'
  },
  {
    name: 'Moldova',
    value: 'MD'
  },
  {
    name: 'Monaco',
    value: 'MC'
  },
  {
    name: 'Mongolia',
    value: 'MN'
  },
  {
    name: 'Montenegro',
    value: 'ME'
  },
  {
    name: 'Montserrat',
    value: 'MS'
  },
  {
    name: 'Morocco',
    value: 'MA'
  },
  {
    name: 'Mozambique',
    value: 'MZ'
  },
  {
    name: 'Myanmar',
    value: 'MM'
  },
  {
    name: 'Namibia',
    value: 'NA'
  },
  {
    name: 'Nauru',
    value: 'NR'
  },
  {
    name: 'Nepal',
    value: 'NP'
  },
  {
    name: 'Netherlands (Holland)',
    value: 'NL'
  },
  {
    name: 'New Caledonia',
    value: 'NC'
  },
  {
    name: 'New Zealand',
    value: 'NZ'
  },
  {
    name: 'Nicaragua',
    value: 'NI'
  },
  {
    name: 'Niger',
    value: 'NE'
  },
  {
    name: 'Nigeria',
    value: 'NG'
  },
  {
    name: 'Niue',
    value: 'NU'
  },
  {
    name: 'Norfolk Island',
    value: 'NF'
  },
  {
    name: 'North Macedonia',
    value: 'MK'
  },
  {
    name: 'Northern Mariana Islands',
    value: 'MP'
  },
  {
    name: 'Norway',
    value: 'NO'
  },
  {
    name: 'Oman',
    value: 'OM'
  },
  {
    name: 'Pakistan',
    value: 'PK'
  },
  {
    name: 'Palau',
    value: 'PW'
  },
  {
    name: 'Palestine',
    value: 'PS'
  },
  {
    name: 'Panama',
    value: 'PA'
  },
  {
    name: 'Papua New Guinea',
    value: 'PG'
  },
  {
    name: 'Paraguay',
    value: 'PY'
  },
  {
    name: 'Peru',
    value: 'PE'
  },
  {
    name: 'Philippines',
    value: 'PH'
  },
  {
    name: 'Pitcairn Island',
    value: 'PN'
  },
  {
    name: 'Poland',
    value: 'PL'
  },
  {
    name: 'Portugal',
    value: 'PT'
  },
  {
    name: 'Puerto Rico',
    value: 'PR'
  },
  {
    name: 'Qatar',
    value: 'QA'
  },
  {
    name: 'Reunion',
    value: 'RE'
  },
  {
    name: 'Romania',
    value: 'RO'
  },
  {
    name: 'Russia',
    value: 'RU'
  },
  {
    name: 'Rwanda',
    value: 'RW'
  },
  {
    name: 'Saint Barthelemy',
    value: 'BL'
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'SH'
  },
  {
    name: 'Saint Kitts and Nevis',
    value: 'KN'
  },
  {
    name: 'Saint Lucia',
    value: 'LC'
  },
  {
    name: 'Saint Martin',
    value: 'MF'
  },
  {
    name: 'Saint Pierre and Miquelon',
    value: 'PM'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    value: 'VC'
  },
  {
    name: 'Samoa',
    value: 'WS'
  },
  {
    name: 'San Marino',
    value: 'SM'
  },
  {
    name: 'Sao Tome and Principe',
    value: 'ST'
  },
  {
    name: 'Saudi Arabia',
    value: 'SA'
  },
  {
    name: 'Senegal',
    value: 'SN'
  },
  {
    name: 'Serbia',
    value: 'RS'
  },
  {
    name: 'Seychelles',
    value: 'SC'
  },
  {
    name: 'Sierra Leone',
    value: 'SL'
  },
  {
    name: 'Singapore',
    value: 'SG'
  },
  {
    name: 'Slovakia',
    value: 'SK'
  },
  {
    name: 'Slovenia',
    value: 'SI'
  },
  {
    name: 'Solomon Islands',
    value: 'SB'
  },
  {
    name: 'Somalia',
    value: 'SO'
  },
  {
    name: 'South Africa',
    value: 'ZA'
  },
  {
    name: 'South Korea',
    value: 'KR'
  },
  {
    name: 'South Sudan',
    value: 'SS'
  },
  {
    name: 'Spain',
    value: 'ES'
  },
  {
    name: 'Sri Lanka',
    value: 'LK'
  },
  {
    name: 'Sudan',
    value: 'SD'
  },
  {
    name: 'Suriname',
    value: 'SR'
  },
  {
    name: 'Svalbard and Jan Mayen',
    value: 'SJ'
  },
  {
    name: 'Sweden',
    value: 'SE'
  },
  {
    name: 'Switzerland',
    value: 'CH'
  },
  {
    name: 'Taiwan',
    value: 'TW'
  },
  {
    name: 'Tajikistan',
    value: 'TJ'
  },
  {
    name: 'Tanzania',
    value: 'TZ'
  },
  {
    name: 'Thailand',
    value: 'TH'
  },
  {
    name: 'Timor-Leste',
    value: 'TL'
  },
  {
    name: 'Togo',
    value: 'TG'
  },
  {
    name: 'Tokelau',
    value: 'TK'
  },
  {
    name: 'Tonga',
    value: 'TO'
  },
  {
    name: 'Trinidad and Tobago',
    value: 'TT'
  },
  {
    name: 'Tunisia',
    value: 'TN'
  },
  {
    name: 'Turkey',
    value: 'TR'
  },
  {
    name: 'Turkmenistan',
    value: 'TM'
  },
  {
    name: 'Turks and Caicos Islands',
    value: 'TC'
  },
  {
    name: 'Tuvalu',
    value: 'TV'
  },
  {
    name: 'Uganda',
    value: 'UG'
  },
  {
    name: 'Ukraine',
    value: 'UA'
  },
  {
    name: 'United Arab Emirates',
    value: 'AE'
  },
  {
    name: 'United Kingdom',
    value: 'GB'
  },
  {
    name: 'United States of America',
    value: 'US'
  },
  {
    name: 'Uruguay',
    value: 'UY'
  },
  {
    name: 'Uzbekistan',
    value: 'UZ'
  },
  {
    name: 'Vanuatu',
    value: 'VU'
  },
  {
    name: 'Venezuela',
    value: 'VE'
  },
  {
    name: 'Vatican City State',
    value: 'VA'
  },
  {
    name: 'Vietnam',
    value: 'VN'
  },
  {
    name: 'Virgin Islands (British)',
    value: 'VG'
  },
  {
    name: 'Virgin Islands (U.S.)',
    value: 'VI'
  },
  {
    name: 'Wallis and Futuna Islands',
    value: 'WF'
  },
  {
    name: 'Western Sahara',
    value: 'EH'
  },
  {
    name: 'Yemen',
    value: 'YE'
  },
  {
    name: 'Zambia',
    value: 'ZM'
  },
  {
    name: 'Zimbabwe',
    value: 'ZW'
  }
]

export const TRANSFERMATE_PAYMENT_METHOD_ID_IMAGE_HEIGHT_ADJUST = [2, 7];

export const SAME_CURRENCY_FEE_TAX_TEXT = "Same currency fee";

export const INDIA_SOURCE_OF_FUND_DROPDOWN = [
  {
    name: 'Resident Savings',
    value: 'resident_savings'
  },
  {
    name: 'Education Loan',
    value: 'education_loan'
  }
]

export const TM_COUNTRY_SPECIFIC_FIELDS = {
  IN: ['india_source_of_fund', 'india_declaration_amt']
}

